import React, { useEffect, useState } from "react";
import { getOwnerOverviewStats, getRecentDocs } from "../../../services/data";

const OWNER_UID = import.meta.env.VITE_OWNER_UID;

export default function OverviewTab(){
  const [kpi, setKpi] = useState({ users: 0, docs30: 0, dossiers30: 0 });
  const [recent, setRecent] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const [stats, docs] = await Promise.all([
          getOwnerOverviewStats(OWNER_UID),
          getRecentDocs(OWNER_UID, { days: 30, limitTo: 10 })
        ]);
        if (!mounted) return;
        setKpi(stats);
        setRecent(docs);
      } catch (e) {
        console.error("Overview load failed:", e);
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => { mounted = false; };
  }, []);

  return (
    <>
      <div className="page-header">
        <h2 className="page-title">Vue d’ensemble</h2>
        <div className="page-actions">
          <button className="btn btn-outline" onClick={() => window.location.reload()}>
            <i className="fas fa-sync-alt"></i> Actualiser
          </button>
          <button className="btn btn-success"><i className="fas fa-magic"></i> Maintenance</button>
        </div>
      </div>

      {/* KPI style maquette (owner.css) */}
      <div className="kpi-grid">
        <div className="kpi-card primary" aria-label="Utilisateurs total">
          <div className="kpi-header">
            <div className="kpi-title">Utilisateurs</div>
            <div className="kpi-icon"><i className="fas fa-users" /></div>
          </div>
          <div className="kpi-value">{loading ? "…" : kpi.users}</div>
          <div className="kpi-label">Total (roles)</div>
          <div className="kpi-trend trend-up">+0% ce mois</div>
        </div>

        <div className="kpi-card secondary" aria-label="Docs 30 jours">
          <div className="kpi-header">
            <div className="kpi-title">Docs (30j)</div>
            <div className="kpi-icon"><i className="fas fa-file-alt" /></div>
          </div>
          <div className="kpi-value">{loading ? "…" : kpi.docs30}</div>
          <div className="kpi-label">Générés</div>
          <div className="kpi-trend trend-up">+0% vs période précédente</div>
        </div>

        <div className="kpi-card warning" aria-label="Dossiers MAJ 30j">
          <div className="kpi-header">
            <div className="kpi-title">Dossiers (30j)</div>
            <div className="kpi-icon"><i className="fas fa-folder-open" /></div>
          </div>
          <div className="kpi-value">{loading ? "…" : kpi.dossiers30}</div>
          <div className="kpi-label">Modifiés</div>
          <div className="kpi-trend">A suivre</div>
        </div>

        <div className="kpi-card danger" aria-label="Erreurs récentes">
          <div className="kpi-header">
            <div className="kpi-title">Erreurs</div>
            <div className="kpi-icon"><i className="fas fa-bug" /></div>
          </div>
          <div className="kpi-value">—</div>
          <div className="kpi-label">24h</div>
          <div className="kpi-trend trend-down">0 incident critique</div>
        </div>
      </div>

      {/* Bloc Docs récents (30j) */}
      <section className="config-section" aria-label="Docs récents">
        <div className="config-header">
          <div className="config-title"><i className="fas fa-clock" /> Documents récents (30j)</div>
          <div className="actions">
            <button className="btn btn-outline"><i className="fas fa-list" /> Voir tout</button>
          </div>
        </div>
        <div className="config-body">
          <div className="table-container">
            <div className="table-header">
              <h3 className="table-title">Dernières générations</h3>
              <div className="table-filters"></div>
            </div>
            <table>
              <thead>
                <tr><th>Titre</th><th>Dossier</th><th>Fichier</th><th>Date</th></tr>
              </thead>
              <tbody>
                {recent.length === 0 && !loading && (
                  <tr><td colSpan={4} className="muted">Aucun document sur 30 jours.</td></tr>
                )}
                {recent.map((d) => (
                  <tr key={d.id}>
                    <td>{d.title || d.fileName || d.id}</td>
                    <td>{d.dossierKey || "—"}</td>
                    <td>
                      {d.fileURL ? (
                        <a href={d.fileURL} target="_blank" rel="noreferrer">ouvrir</a>
                      ) : "—"}
                    </td>
                    <td>{d.createdAt?.toDate ? d.createdAt.toDate().toLocaleString() : "—"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="table-footer">
              <div className="table-info">{recent.length} élément(s)</div>
              <div className="pagination"><button className="pagination-btn active">1</button></div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
